import type { FC } from 'react'
import React from 'react'
import { emojis } from './consts'
import type { EmojiProps } from './types'

export const Emoji: FC<EmojiProps> = ({ shortcode }) => {
  const { name, html } = emojis[shortcode]

  return <span dangerouslySetInnerHTML={{ __html: html }} role="img" aria-label={`${name} emoji`} />
}
